export const name = "MIN_BY";
export const summary = `Synonym for \`ANY_VALUE(x HAVING MIN y)\`.`;
export const reference = `
## MIN_BY

Synonym for \`ANY_VALUE(x HAVING MIN y)\`.

\`\`\`
MIN_BY(
  x, y
)
\`\`\`

### Description

Synonym for \`ANY_VALUE(x HAVING MIN y)\`.


### Return Data Types

Matches the input \`x\` data type.


### Examples



\`\`\`
WITH fruits AS (
  SELECT "apple" fruit, 3.55 price UNION ALL
  SELECT "banana" fruit, 2.10 price UNION ALL
  SELECT "pear" fruit, 4.30 price
)
SELECT MIN_BY(fruit, price) as fruit
FROM fruits;

/*--------*
 | fruit |
 +--------+
 | banana |
 *--------*/
\`\`\`


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/aggregate_functions
`;
